import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-detalhes',
  templateUrl: './detalhes.component.html',
  styleUrls: ['./detalhes.component.scss']
})

export class DetalhesComponent implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
